import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/Homepage';
import TalktailAppMain from './pages/TalktailApp';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AccountDeletion from './pages/AccountDeletion';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/talktailApp" element={<TalktailAppMain />} />
          <Route path="/talktailApp/privacy" element={<PrivacyPolicy />} />
          <Route path="/talktailApp/deletion" element={<AccountDeletion />} />

        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
